import { render, staticRenderFns } from "./KeyInfo.vue?vue&type=template&id=1c280848"
import script from "./KeyInfo.vue?vue&type=script&lang=js"
export * from "./KeyInfo.vue?vue&type=script&lang=js"
import style0 from "./KeyInfo.vue?vue&type=style&index=0&id=1c280848&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports